import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import Login from '../pages/Login';
import Inicio from '../pages/Inicio';
import Covisage from '../pages/Covisage';
import Systemic from '../pages/Systemic';
import CreatividadesLayout from '../pages/Creatividades/CreatividadesLayout';
import CreativeLeadership from '../pages/CreativeLeadership';
import { useAuth } from '../features/AuthContext';
import styles from '../styles/app.module.css';

function Layout() {
    return (
        <div className={styles.appContainer}>
            <Sidebar />
            <main className={styles.mainContent}>
                <Header title="Panel de Empresa" />
                <div className={styles.pageContent}>
                    <Outlet />
                </div>
            </main>
        </div>
    );
}

function ProtectedRoute({ children }) {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }
    return children;
}

function PublicRoute({ children }) {
    const { isAuthenticated } = useAuth();
    if (isAuthenticated) {
        return <Navigate to="/dashboard" replace />;
    }
    return children;
}

function RoutesComponent() {
    const { authResolved, loading } = useAuth();

    if (!authResolved || loading) {
        return (
            <div className={styles.appContainer} style={{ alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ width: 40, height: 40, border: '3px solid var(--border-light)', borderTopColor: 'var(--accent-primary)', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
            </div>
        );
    }

    return (
        <Router>
            <Routes>
                <Route path="/login" element={
                    <PublicRoute>
                        <Login />
                    </PublicRoute>
                } />
                <Route path="/" element={
                    <ProtectedRoute>
                        <Layout />
                    </ProtectedRoute>
                }>
                    <Route index element={<Navigate to="/dashboard" replace />} />
                    <Route path="dashboard" element={<Inicio />} />
                    <Route path="covisage" element={<Covisage />} />
                    <Route path="systemic" element={<Systemic />} />
                    <Route path="creatividades/*" element={<CreatividadesLayout />} />
                    <Route path="creative-leadership" element={<CreativeLeadership />} />
                </Route>
                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
        </Router>
    );
}

export default RoutesComponent;
